export const ONLINE = "online";
export const MAINTENANCE = "maintenance";
export const UNAVAILABLE = "unavailable";



// WEBPACK FOOTER //
// ./src/StatusOptions.js